import { Page, NotificationBox } from "@components";

const NotificationsScreen: React.FC<any> = () => (
  <Page title="Notifications">
    <NotificationBox></NotificationBox>
  </Page>
);

export default NotificationsScreen;
